// extracted by mini-css-extract-plugin
export default {"navbarWrapper":"Navbar_navbarWrapper__LxPJG","headerLinks":"Navbar_headerLinks__+obLQ","item":"Navbar_item__ExRhO","activeIcon":"Navbar_activeIcon__HI2zE"};